/**
 * Console-Rollen: Administrator, Auditor, Lehrer.
 */
export function currentConsoleUser() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function isAdministrator() {
  return currentConsoleUser()?.userType === "consoleAdministrator";
}

export function isTeacher() {
  return currentConsoleUser()?.userType === "consoleTeacher";
}

export function isStaff() {
  return isAdministrator() || isTeacher();
}

export default isAdministrator;
